import React, { useState, useEffect } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import '../../pages/Faq/Faqs.css';
import './Notification.css';
import AddButtonSecond from '../../components/common/AddButton/AddSecondButton';
import AddNotification from '../../components/Popup/AddPopup/AddNotification';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import { isRequired } from '../../validation';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
const pageKey = "notification"

const NotificationList = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [popupTitle, setPopupTitle] = useState('');
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [activeButton, setActiveButton] = useState("Push Notifications");
  const [popupError, setPopupError] = useState('');
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [categories, setCategories] = useState([]);
  const [recipients, setRecipient]= useState([]);
  const [selectedNoti, setSelectedNoti] = useState(null);
  const [formattedDate, setFormattedDate] = useState('');
  const [formattedTime, setFormattedTime] = useState('');
  const navigate = useNavigate();
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(filteredNotifications);
  const [exportState, setExportState] = useState({
    isExporting: false,
    error: null
  });

  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];

  useEffect(() => {
    fetchNotifications();
    fetchCategories();
    fetchUser();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]);
  
  const fetchNotifications = async (id = null) => {
    try {
      let response;
  
      if (id) {
        response = await authenticatedAxios.get(`${baseurl}notifications/?id=${id}`);
        if (response?.data) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          console.error("No data found for the selected notification.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        response = await authenticatedAxios.get(`${baseurl}notifications/`, { params });
        setItems(response.data?.data || []);
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching notifications:', error);
      }
    }
  };
  

  const fetchCategories = async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}notifications/category/active/`);
        
        if (response.data.response_code === 1) {
            const options = response.data.data.map(category => ({
                label: category.name,  // Display name for the dropdown
                value: category.id     // Unique identifier
            }));
            setCategories(options); 
            
        } else {
            console.error('Error fetching categories:', response.data.message);
        }
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}notifications/recipient-groups/`); 
      const options = (response.data.data || []).map(user => ({
        label: user.name,
        value: user.id     
      }));
      setRecipient(options); 
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleAddNotification = async (formValues) => {
    try {
        // Create a new object with all existing form values
        const updatedFormValues = {
            ...formValues,
            scheduled_at: `${formValues.date}T${formValues.time}`,
            notification_type: selectedNoti // Add the notification type here
        };

        // Remove date and time fields
        delete updatedFormValues.date;
        delete updatedFormValues.time;


        const response = await authenticatedAxios.post(
            `${baseurl}notifications/`,
            updatedFormValues
        );

        if (response.data.response_code === 1) {
          await fetchNotifications();
          setPopupError('');
          closePopups();
        } else {
          setPopupError(response.data.message || 'Something went wrong!');
        }
      } catch (error) {
        setPopupError('Failed to add plan. Please try again.');
      }
    }
  
//   const handleAddNotification = async (formValues) => {
//     try {
//         // Log the initial form values for debugging
//         console.log("Initial Form Values:", formValues);

//         // Prepare the notification data
//         const updatedFormValues = {
//             ...formValues,
//             scheduled_at: `${formValues.date}T${formValues.time}`,
//             notification_type: selectedNoti,
            
//             // Handle category with explicit name
//             category: {
//                 id: formValues.category?.value || formValues.category,
//                 name: formValues.category?.label || 
//                       (formValues.category && typeof formValues.category === 'object' 
//                        ? formValues.category.name 
//                        : formValues.categoryName) || 
//                       // Fallback to fetching name from categories list if possible
//                       (categories.find(cat => cat.id === (formValues.category?.value || formValues.category))?.name)
//             },
            
//             // Handle recipients with explicit name
//             recipients: {
//                 id: formValues.recipients?.value || formValues.recipients,
//                 name: formValues.recipients?.label || 
//                       (formValues.recipients && typeof formValues.recipients === 'object' 
//                        ? formValues.recipients.name 
//                        : formValues.recipientsName) || 
//                       // Fallback to fetching name from recipients list if possible
//                       (recipientGroups.find(group => group.id === (formValues.recipients?.value || formValues.recipients))?.name)
//             },
            
//             // Ensure repeat is handled correctly
//             repeat: formValues.repeat?.value || formValues.repeat || 'Now'
//         };

//         // Remove unnecessary fields
//         delete updatedFormValues.date;
//         delete updatedFormValues.time;

//         // Log the updated form values before sending the request
//         console.log("Notification Data to be sent:", updatedFormValues);

//         const response = await authenticatedAxios.post(
//             `${baseurl}notifications/`,
//             updatedFormValues
//         );

//         if (response.status >= 200 && response.status < 300) {
//             await fetchNotifications();
//             closePopups();
//         }
//     } catch (error) {
//         console.error('Error adding notification:', error);
//         if (error.response) {
//             console.error('Server error:', error.response.data);
//             // Handle specific validation errors
//             if (error.response.data.category) {
//                 alert('Please provide a category name');
//             }
//             if (error.response.data.recipients) {
//                 alert('Please provide recipient group details');
//             }
//         }
//     }
// };

  
  const handleEdit = async (formValues) => {
    try {
      const updatedFormValues = { ...formValues };

      // Check if either date or time is present
      if (formValues.date || formValues.time) {
        const { date: oldDate, time: oldTime } = formatScheduleDateTime(selectedItem.scheduled_at);

        const finalDate = formValues.date || oldDate;
        const finalTime = formValues.time || oldTime;

        updatedFormValues.scheduled_at = `${finalDate}T${finalTime}`;
      }

      const response = await authenticatedAxios.put(
        `${baseurl}notifications/?id=${selectedItem.id}`,
        updatedFormValues
      );

      if (response.data.response_code === 1) {
        await fetchNotifications();
        closePopups();
      }
    } catch (error) {
      console.error('Error editing notification:', error);
      if (error.response) {
        console.error('Server error:', error.response.data);
      }
    }
  };


  
  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}notifications/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchNotifications();
        resetCheckboxState();
        closePopups();
      } 
    } catch (error) {
      // console.error('Error archiving/unarchiving selected items:', error);
    }
  };

  const handleArchive = async () => {
    try {
      const response = await authenticatedAxios.get(
        `${baseurl}notifications/archive/?id=${selectedItem.id}`
      );
      
      if (response.status >= 200 && response.status < 300) {
        setIsArchivePopupOpen(false);
        fetchNotifications(); 
        closePopups();
        return;
      }
      
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error archiving notification:', error);
    }
  };
 
  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}notifications/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchNotifications(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
  };
  
  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const formatScheduleDateTime = (isoDateTime) => {
    if (!isoDateTime) return { date: '', time: '' };
    
    // Split into date and time parts
    const [datePart, timePart] = isoDateTime.split('T');
    // Keep date as YYYY-MM-DD for HTML date input
    const date = datePart;
    // Keep time as HH:MM for HTML time input
    const time = timePart.slice(0, 5);
  
    return { date, time };
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };
  
  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  // const handleOptionSelect = (selectedOption) => {
  //   setPopupTitle(selectedOption); 
  //   setIsNewPopupOpen(true);
  // };
  // const handleEditClick = (item, selectedOption) => {
  //   fetchNotifications(item.id)
  //   setSelectedNoti(selectedOption);
  //   fetchCategories();
  
  //   const { date, time } = formatScheduleDateTime(item.scheduled_at);
  //   setFormattedDate(date);
  //   setFormattedTime(time);
  // };

  const handleEditClick = (item) => {
    setIsEditPopupOpen(true)
    setSelectedItem(item)

    const { date, time } = formatScheduleDateTime(item.scheduled_at);
    setFormattedDate(date);
    setFormattedTime(time);
  };


  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleNewClick = (selectedOption) => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
    fetchCategories();
    setSelectedNoti(selectedOption);
    setPopupTitle(`Add ${selectedOption}`);
    
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  useEffect(() => {
    // Filter notifications based on active button
    const filterNotifications = () => {
      const filtered = items.filter(notification => notification.notification_type === activeButton);
      setFilteredNotifications(filtered);
    };
    filterNotifications();
  }, [items, activeButton]);

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDeletePopupOpen(false);
    setSelectedItem(null);
    setPopupError('');
  };
  const addPopupFields = [
    { label: 'Notification Content',name:'content', type: 'rich-text', defaultValue: '', validators: [isRequired] },
    { label: 'Category', name:'category', type: 'large-select', options:categories,defaultValue: '',validators: [isRequired]},
    { label: 'Schedule Date',name:'date', type: 'date', defaultValue: '', validators: [isRequired] },
    { label: 'Schedule Time',name: 'time', type: 'time', defaultValue: '', validators: [isRequired] },
    { label: 'Repeat',name:'repeat', type: 'large-select', options: [{ label: 'now', value: 'Now' },{ label: 'daily', value: 'Daily' },{ label: 'weekly', value: 'Weekly' }, { label: 'monthly', value: 'Monthly' }], defaultValue: '', onChange: () => {},validators: [isRequired] },
    { label: 'Recipients',name:'recipients', type: 'large-select', options: recipients, defaultValue: '',validators: [isRequired]},
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to archive this record? Once archived, the data will be inaccessible and may impact ongoing customer interactions.', type: 'text' },
  ];
  const editPopupFields = [
    {
      label: 'Notification Content',
      name: 'content',
      type: 'rich-text',
      defaultValue: selectedItem?.content || 'N/A',
    },
    {
      label: 'Category',
      name: 'category',
      type: 'large-select',
      defaultValue: selectedItem?.category.name || 'N/A',
      options:categories
    },
    {
      label: 'Schedule Date',
      name: 'date',
      type: 'date',
      defaultValue: formattedDate|| '',
      
    },
    {
      label: 'Schedule Time',
      name: 'time',
      type: 'time',
      defaultValue: formattedTime || '',
      
    },
    {
      label: 'Repeat',
      name: 'repeat',
      type: 'large-select',
      options: [
        { label: 'Daily', value: 'Daily' },
        { label: 'Weekly', value: 'Weekly' },
        { label: 'Monthly', value: 'Monthly' },
      ],
      defaultValue: selectedItem?.repeat || '',
    
    },
    {
      label: 'Recipients',
      name: 'recipients',
      type: 'large-select',
      options: recipients,
      defaultValue: selectedItem?.recipients || '',
     
    },
  ];
  const handleExportStart = () => {
    setExportState({ isExporting: true, error: null });
  };

  const handleExportComplete = () => {
    setExportState({ isExporting: false, error: null });
    resetCheckboxState();
  };

  const handleExportError = (error) => {
    setExportState({ isExporting: false, error });
  };  
  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName=" Notifications /" nestedpageName="Notification-list"  linkTo="" /> 
        <div className='export-container'>
          <ArchiveSelectedItem
            selectedItems={selectedItems}
            items={items}
            onArchiveSelected={handleArchiveSelectedItems}
          />
          <ExportLabel
            exportUrl={`${baseurl}notifications/export/`}
            selectedIds={selectedItems}
            onExportStart={handleExportStart}
            onExportComplete={handleExportComplete}
            onExportError={handleExportError}
          />
        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Notification List</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButtonSecond addoptions={['Push Notifications', 'Email Notifications', 'SMS Notifications']} onOptionSelect={handleNewClick} />
          <SimpleSearchBox placeholder="Search Notification" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>

      </div>
      <div className="notification-button-group button-group">
        <button
          className={`toggle-button common-text fts-15 ftw-4 ${activeButton === "Push Notifications" ? "active-button" : ""}`}
          onClick={() => handleButtonClick("Push Notifications")}
        >
          Push Notifications
        </button>
        <button
          className={`toggle-button common-text fts-15 ftw-4 ${activeButton === "Email Notifications" ? "active-button" : ""}`}
          onClick={() => handleButtonClick("Email Notifications")}
        >
          Email Notifications
        </button>
        <button
          className={`toggle-button common-text fts-15 ftw-4 ${activeButton === "SMS Notifications" ? "active-button" : ""}`}
          onClick={() => handleButtonClick("SMS Notifications")}
        >
          SMS Notifications
        </button>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th className='w-45 d-flex'>
                  <div className=''>
                    <input
                      className="table-selectbox table-parent-selectbox"
                      type="checkbox"
                      checked={isParentSelected}
                      onChange={handleParentCheckboxChange}
                    />
                  </div>
                  <div className='w-80'>Content</div>
              </th>
              <th className='w-15'>Category</th>
              <th className='w-15'>Date & time</th>
              <th className='w-13'>Recipient</th>
              
              <th className=' w-12'></th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
            {filteredNotifications.length > 0 ? (
              filteredNotifications.map((notification) => (
                <tr key={notification.id} id='p-relative' className= {notification.is_archived ? 'archived-item' : ''}>
                  <td className=' w-45'>
                    <div className='tick-box'>
                      <div>
                      <input
                        className="table-selectbox table-child-selectbox "
                        type="checkbox"
                        checked={selectedItems.includes(notification.id)}
                        onChange={() => handleChildCheckboxChange(notification.id)}
                      />
                      </div>
                      <img src={`${baseurl.replace(/\/$/, '')}${notification.category.icon}`} alt={`${notification.category.name} icon`} className='notification-category-icon' />
                      <div className='mr-30' dangerouslySetInnerHTML={{ __html: notification.content }} />
                    </div>
                  </td>     
                  <td className='w-15'>{notification.category.name}</td>
                  {/* <td>{notification.scheduled_at}</td> */}
                  <td className='w-15'>
                    {(() => {
                      const d = new Date(notification.scheduled_at);
                      const day = d.getDate().toString().padStart(2, '0');
                      const month = (d.getMonth() + 1).toString().padStart(2, '0');
                      const year = d.getFullYear();
                      const hours = d.getHours().toString().padStart(2, '0');
                      const minutes = d.getMinutes().toString().padStart(2, '0');
                      return `${day}-${month}-${year} - ${hours}:${minutes}`;
                    })()}
                  </td>

                  {/* <td>{new Date(notification.scheduled_at).toLocaleDateString('en-GB')}</td> */}
                  <td className='w-13'>{notification.recipients.name}</td>    
                  <td className="actions notification-action w-12">
                    <EditIcon onClick={() => handleEditClick(notification)} />
                    <ArchiveIcon onClick={() => handleArchiveClick(notification)}  isArchived={notification.is_archived}/>
                    <DeleteIcon onClick={() => handleDeleteClick(notification)} />
                  </td>       
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No notifications available for this type.</td>
              </tr>
            )}
          </tbody> 
        </table>
      </div>
      <EditPopup 
          isOpen={isEditPopupOpen}
          title="State"
          fields={editPopupFields}
          onSave={handleEdit}
          onClose={closePopups}
        />
        
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.content?.replace(/<\/?p>/g, '').substring(0, 10)}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />            
      <DeletePopup 
        isOpen={isDeletePopupOpen}
        title="Delete"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />
      {isNewPopupOpen && (
        <AddNotification
        isOpen={isNewPopupOpen}
        title={popupTitle} 
        buttonname="Sent Now"
        fields={addPopupFields}
        onSave={handleAddNotification}
        onClose={closePopups} 
        popupErrorMessage={popupError}
        />
      )}
    </div>
  );
};

export default NotificationList;